import React, { useState, useEffect, useCallback } from "react";
import Moment from "react-moment";
import "moment/locale/fr";
import moment from "moment";

import { server, socket } from "../../App";
import axios from "axios";
import { Button } from "semantic-ui-react";

import { useSelector } from "react-redux";
import {
  selectPatientelleGrid,
} from "../../features/patientelle/patientelleSlice";
import { selectisAuthenticated } from "../../features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";


function IntervalReady() {

  const [DateTime1, setDateTime1] = useState();
  const [counter, setCounter] = useState(false);
  const [, setDateTime2] = useState();
  let navigate = useNavigate();

  const PatientelleState = useSelector(selectPatientelleGrid);
  const AuthState = useSelector(selectisAuthenticated);
  const { date_consultation, idpatient } = PatientelleState;

  let date = moment().format("YYYY-MM-DD"); //////////////////////////

  // const GetData = async (data, m) => {
  //   let url, url2;
  //   if (data?.length > 9) {
  //     url = `${server}actes/ActesAtDate/${data}`;
  //     url2 = `${server}actes/ActesAtDateFooter/${data}`;
  //   }

  //   await axios
  //     .get(url, {
  //       headers: {
  //         jwtoken: sessionStorage.token,
  //       },
  //     })
  //     .then((response) => {
  //       dispatch(fetch_success(response.data));
  //     })

  //     .catch((error) => {
  //       console.log(error);
  //     });
  //   await axios
  //     .get(url2, {
  //       headers: {
  //         jwtoken: sessionStorage.token,
  //       },
  //     })
  //     .then((response) => {
  //       dispatch(fetch_success_DUO(response.data));
  //     })

  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // useEffect(
  //   () => {
  //     function receivedMessage(m) {
  //       GetData(date, m);
  //     }
  //     socket.on("delete", receivedMessage);
  //     socket.on("add", receivedMessage);
  //     socket.on("update", receivedMessage);
  //     socket.on("transfer", receivedMessage);
  //     return () => {
  //       socket.on("delete", receivedMessage);
  //       socket.off("add", receivedMessage);
  //       socket.off("update", receivedMessage);
  //       socket.off("transfer", receivedMessage);
  //     };
  //   },

  //   // eslint-disable-next-line
  //   []
  // );

  const handleTransferToDoneList = async () => {
    const data = {
      date_consultation: date_consultation,
      fk_id_patient1: idpatient,
      done: 0,
      bloc: 0,
      didnt_come: 0,
    };

    await axios({
      method: "put",
      responseType: "json",
      url: `${server}actesDone/updateActe`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    }).then((response) => {
      socket.emit("transfer", data);
      toast("transfer à accomplie", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setCounter(true);
    });
  };

  function GetTime() {
    let date_De_consultation = moment().format();
    setDateTime1(date_De_consultation);
  }

  useEffect(() => {
    GetTime();
  }, []);

  const updateConsultationTime = async (ConsultationTime) => {
    const data = {
      updated_by: AuthState.user_name,
      fk_id_patientConsul: idpatient,
      DateConsultation: date_consultation ? date_consultation : date,
      ConsultationTime: ConsultationTime,
    };

    await axios({
      method: "put",
      responseType: "json",
      url: `${server}Consultation/TimeCons`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        handleTransferToDoneList();
        // navigate(-1);
        // forceUpdate();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function GetTime2() {
    let date_De_consultation = moment().format();
    setDateTime2(date_De_consultation);
    let diffrence = moment(date_De_consultation).diff(
      moment(DateTime1),
      "seconds"
    );
    let ConsultationTime;
    if (diffrence < 60) {
      ConsultationTime = `${diffrence}s`;
    } else if (diffrence >= 60) {
      let minutes = parseInt(diffrence / 60);
      let secondes = diffrence % 60;
      ConsultationTime = `${minutes}m ${secondes}s`;
    }
    updateConsultationTime(ConsultationTime);
  }

  const forceUpdate = useCallback(() => navigate(-1), [navigate]);

  let result;
  if (date_consultation) {
    if (counter === false) {
      result = (
        <Button
          color="green"
          onClick={() => {
            GetTime2();
          }}
          content="Save"
          icon="clock"
          labelPosition="right"
        />
      );
    } else {
      result = (
        <Button
          onClick={() => forceUpdate()}
          content="Retour"
          icon="clock"
          labelPosition="right"
          color="orange"
        />
      );
    }
  } else {
    result = null;
  }

  return (
    <>
      <div className="chronometre">
        <Moment
          interval={1000}
          date={DateTime1}
          format="hh:mm:ss"
          durationFromNow
        />
      </div>

      {result}

      <Button color="blue" onClick={() => forceUpdate()} floated="right">
        Retour
      </Button>
    </>
  );
}

export default IntervalReady;
